import { useMutation, useQuery } from 'react-query';
import { AllSprintService } from '@api/AllSprintService';
import { onDefaultError } from '../helpers/commonHelpers';

/**
 * Fetch list of sprints
 * @param [page_no, searchText, status] - query parameters
 * @param onSuccess - callback on success
 * @param onError - callback on error
 */
const useListAllSprint = ([page_no, searchText, projectId, managerID, deliveryManagerID, paymentStatusTypesID, profitibilityStatusID, selectedFilterDateBy, fromDate, toDate], onSuccess, onError = onDefaultError) => {
  return useQuery(
    ['sprint-list', page_no, searchText, projectId, managerID, deliveryManagerID, paymentStatusTypesID, profitibilityStatusID, selectedFilterDateBy, fromDate, toDate],
    () => AllSprintService.listAllSprint({ page_no, searchText, projectId, managerID, deliveryManagerID, paymentStatusTypesID, profitibilityStatusID, selectedFilterDateBy, fromDate, toDate }),
    {
      onSuccess,
      keepPreviousData: true,
      onError
    }
  );
};

/**
 * Add a new sprint
 */
const useAddSprint = (onSuccess, onError = onDefaultError) => {
  return useMutation(SprintService.addSprint, { onSuccess, onError });
};

/**
 * View sprint details
 */
const useViewSprint = (id, onSuccess, onError = onDefaultError) => {
  return useQuery(['sprint-view', id], () => SprintService.viewSprint(id), { onSuccess, onError });
};

/**
 * Update sprint
 */
const useUpdateSprint = (onSuccess, onError = onDefaultError) => {
  return useMutation(SprintService.updateSprint, { onSuccess, onError });
};

/**
 * Change sprint status (if API supports it)
 */
const useStatusChangeSprint = (onSuccess, onError = onDefaultError) => {
  return useMutation(SprintService.changeStatusSprint, { onSuccess, onError });
};

/**
 * Delete sprint
 */
const useDeleteSprint = (onSuccess, onError = onDefaultError) => {
  return useMutation(SprintService.deleteSprint, { onSuccess, onError });
};

// Project List
const useGetAllSprintProjects = (onSuccess, onError = onDefaultError) => {
    return useQuery('project-list', () => AllSprintService.projectList(), {
        onSuccess,
        keepPreviousData: true,
        onError,
    });
};

// Sprint Project Count for next 7 days and today and overdue
const useSprintProjectCount = (projectId, onSuccess, onError = onDefaultError) => {
  return useQuery(['project-list-count', projectId], () => AllSprintService.getSprintProjectCount(projectId), {
    onSuccess, onError 
  });
};

export {
  useListAllSprint,
  useAddSprint,
  useViewSprint,
  useUpdateSprint,
  useDeleteSprint,
  useStatusChangeSprint,
  useGetAllSprintProjects,
  useSprintProjectCount
};